// extracted by mini-css-extract-plugin
export var promotionLink = "_vo-0";